import { render } from "./course.vue?vue&type=template&id=1dc78468&scoped=true"
import script from "./course.vue?vue&type=script&lang=js"
export * from "./course.vue?vue&type=script&lang=js"

import "./course.vue?vue&type=style&index=0&id=1dc78468&scoped=true&lang=css"

import exportComponent from "D:\\Code\\zt\\Leader\\newui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc78468"]])

export default __exports__